import React from "react";
import { styled } from "@glitz/react";
import { spacing, green } from "../../theme";

type LoaderProps = {
  /** Optional label for screen readers */
  ariaLabel?: string;
};

const Loader: React.FC<LoaderProps> = ({ ariaLabel = "Laddar" }) => {
  return (
    <LoaderWrapper role="status" aria-label={ariaLabel}>
      <Spinner className="loader-spinner" />
    </LoaderWrapper>
  );
};

const LoaderWrapper = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: { xy: spacing.xxl },
  minHeight: "120px",
});

const Spinner = styled.div({
  width: "40px",
  height: "40px",
  border: { xy: { style: "solid", color: "transparent", width: "3px" } },
  borderTopColor: green,
  borderRadius: "50%",
});

export default Loader;
